export const EventNameByIdentifier = {
	'copy': 'Copy',
	'paste': 'Paste',
	'tab-displayed': 'Tab displayed',
	'tab-hidden': 'Tab hidden',
	'tab-focus-in': 'Tab focus-in',
	'tab-focus-out': 'Tab focus-out',
	'code-run': 'Code run'
};
export const EventColorByIdentifier = {
	'copy': 'rgb(255, 159, 64)',
	'paste': 'rgb(255, 99, 132)',
	'tab-displayed': 'rgb(75, 192, 192)',
	'tab-hidden': 'rgb(153, 102, 255)',
	'tab-focus-in': 'rgb(75, 192, 192)',
	'tab-focus-out': 'rgb(153, 102, 255)',
	'code-run': 'rgb(201, 203, 207)'
};

export const toHhMmSs = (secs) => {
	const secNum = parseInt(secs, 10);
	const hours = Math.floor(secNum / 3600);
	const minutes = Math.floor(secNum / 60) % 60;
	const seconds = secNum % 60;

	return [hours, minutes, seconds]
		.map((v) => v < 10 ? '0' + v : v)
		.filter((v, i) => v !== '00' || i > 0)
		.join(':');
};



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/components/hack-results-viewer/chart-utils.ts